<template>
  <div id="app">
    <v-app>
      <div class="page-wrapper compact-wrapper" id="pageWrapper">
      <!-- Page Header Start-->
      <div class="page-main-header" v-if="$user != null">
        <div class="main-header-right row m-0">
          <div class="main-header-left">
            <div class="logo-wrapper"><a @click="$router.push('dashboard')"><img class="img-fluid" style="max-height: 70px" :src="`/static/images/logo/logo-${$adnetworkTheme}.png`" alt=""></a></div>
            <div class="dark-logo-wrapper"><a href="index.html"><img class="img-fluid" src="/static/images/logo/dark-logo.png" alt=""></a></div>
            <div @click="sidebar = !sidebar" class="toggle-sidebar"><align-center-icon size="1.5x" class="status_toggle middle" data-feather="align-center custom-class" id="sidebar-toggle" ></align-center-icon> </div>
          </div>
          <div class="left-menu-header col">
            <ul class="mb-0">
              <li>
                <form class="form-inline search-form">
                  <div class="search-bg"><i class="fa fa-search"></i>
                    <input class="form-control-plaintext" v-model="globalSearch" :placeholder="$t('search') + '...'">
                  </div>
                </form><span class="d-sm-none mobile-search search-bg"><i class="fa fa-search"></i></span>
              </li>
            </ul>
          </div>
          <div class="nav-right col pull-right right-menu p-0">
            <ul class="nav-menus mb-0">
              <li class="onhover-dropdown p-0">
                <button class="btn btn-primary" @click="(showChargeAccountPopup = true), (globalSearch = '')" type="button">€&nbsp;{{ $t("charge_account") }}</button>
              </li>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <li v-on="on"><a class="text-dark" href="#!" onclick="javascript:toggleFullScreen()"><maximize-icon class="custom-class"></maximize-icon></a></li>

                </template>
                <span>{{$t('fullscreen')}}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                <li v-on="on">
                    <v-select
                      class="languagepicker"
                      :menu-props="{minWidth: '180'}"
                      v-model="selectedlanguage"
                      :items="possiblelanguages"
                      append-icon=""
                      item-text="name"
                      item-value="shortForm"
                      hide-details
                      @input="setLanguage(selectedlanguage)"
                    >
                      <template slot="item" slot-scope="data">
                        <img style="width:26px;height:17px;vertical-align: unset;" :src="'/files/flags/' + data.item.flag"> &nbsp; {{data.item.name}}
                      </template>
                      <template slot='selection' slot-scope='{item}'>
                        <img style="width:26px;height:17px;vertical-align: unset;" :src="'/files/flags/' + item.flag">
                      </template>
                    </v-select>
              </li>
                </template>
                <span>{{$t('change_language')}}</span>
              </v-tooltip>
              
              <!-- <li>
                <div class="mode"><i class="fa fa-moon-o"></i></div>
              </li> -->
              <!-- TODO: Notifications over Email show here -->
              <!-- <li class="onhover-dropdown"><message-square-icon class="custom-class"></message-square-icon>
                <ul class="chat-dropdown onhover-show-div">
                  <li>
                    <div class="media"><img class="img-fluid rounded-circle me-3" src="/static/images/user/4.jpg" alt="">
                      <div class="media-body"><span>Ain Chavez</span>
                        <p class="f-12 light-font">Lorem Ipsum is simply dummy...</p>
                      </div>
                      <p class="f-12">32 mins ago</p>
                    </div>
                  </li>
                  <li>
                    <div class="media"><img class="img-fluid rounded-circle me-3" src="/static/images/user/1.jpg" alt="">
                      <div class="media-body"><span>Erica Hughes</span>
                        <p class="f-12 light-font">Lorem Ipsum is simply dummy...</p>
                      </div>
                      <p class="f-12">58 mins ago</p>
                    </div>
                  </li>
                  <li>
                    <div class="media"><img class="img-fluid rounded-circle me-3" src="/static/images/user/2.jpg" alt="">
                      <div class="media-body"><span>Kori Thomas</span>
                        <p class="f-12 light-font">Lorem Ipsum is simply dummy...</p>
                      </div>
                      <p class="f-12">1 hr ago</p>
                    </div>
                  </li>
                  <li class="text-center"> <a class="f-w-700" href="javascript:void(0)">See All     </a></li>
                </ul>
              </li> -->
              <li class="onhover-dropdown p-0">
                <button class="btn btn-primary-light" @click="logout()" type="button"><a href="javascript:void(0)"><log-out-icon class="custom-class"></log-out-icon>Log out</a></button>
              </li>
            </ul>
          </div>
          <div class="d-lg-none mobile-toggle pull-right w-auto"><i data-feather="more-horizontal"></i></div>
        </div>
      </div>
      <div class="page-body-wrapper sidebar-icon" >
        <!-- Page Sidebar Start-->
        <header v-bind:class="sidebar ? 'close_icon' : ''" class="main-nav" v-if="$user != null">
          <div class="sidebar-user text-center">
            <!-- <a class="setting-primary" href="javascript:void(0)"><settings-icon class="custom-class"></settings-icon></a> -->
            <img class="img-90 rounded-circle" :src="profileImage" alt="Profile Image">
            <a href="#" @click="$router.push('tenants')">
              <h6 class="mt-3 f-14 f-w-600" v-if="$user != null">{{user.firstname}} {{user.lastname}}</h6>
            </a>
            <p class="mb-0 font-roboto">{{ user.tenantName }}</p>
            <ul style="padding-left: 0px;">
              <li><span><span class="counter">{{ activeAdsCount }}</span></span>
                <p>{{ $t("active_ads") }}</p>
              </li>
              <li><span class="counter">{{ $formatCurrency(currentBudget) }}€</span>
                <p>{{ $t("budget") }}</p>
              </li>
            </ul>
          </div>
          <nav>
            <div class="main-navbar">
              <div class="left-arrow" id="left-arrow"><i data-feather="arrow-left"></i></div>
              <div id="mainnav">
                <ul class="nav-menu custom-scrollbar">
                  <li class="back-btn">
                    <div class="mobile-back text-end"><span>Back</span><i class="fa fa-angle-right ps-2" aria-hidden="true"></i></div>
                  </li>
                  <li class="sidebar-main-title">
                    <div>
                      <h6>{{$t('general')}}</h6>
                    </div>
                  </li>     
                  <li class="dropdown" v-if="$rights.includes('VIEW_DASHBOARD')"><a class="nav-link menu-title" @click="$router.push('dashboard').catch(err => {})"><home-icon class="custom-class"></home-icon><span>{{$t("dashboard")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('MANAGE_ADVERTISEMENTS')"><a class="nav-link menu-title" @click="$router.push('advertisements').catch(err => {})"><smartphone-icon class="custom-class"></smartphone-icon><span>{{$t("advertisements")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('MANAGE_TARGETGROUPS')"><a class="nav-link menu-title" @click="$router.push('targetgroups').catch(err => {})"><target-icon class="custom-class"></target-icon><span>{{$t("targetgroups")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('VIEW_TRANSACTIONS')"><a class="nav-link menu-title" @click="$router.push('purchases').catch(err => {})"><credit-card-icon class="custom-class"></credit-card-icon><span>{{$t("transactions")}}</span></a></li>
                  <li class="dropdown"><a class="nav-link menu-title" @click="$router.push('benefits').catch(err => {})"><star-icon class="custom-class"></star-icon><span>{{$t("expertBenefits")}}</span></a></li>
                  
                  <li class="sidebar-main-title" v-if="$rights.includes('VIEW_USER') || $rights.includes('MANAGE_ROLES') || $rights.includes('TENANT_INDEPENDENCE')">
                    <div>
                      <h6>{{$t("management")}}</h6>
                    </div>
                  </li>
                  <li class="dropdown" v-if="$rights.includes('VIEW_USER')"><a class="nav-link menu-title" @click="$router.push('users').catch(err => {})"><users-icon class="custom-class"></users-icon><span>{{$t("user management")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('MANAGE_ROLES')"><a class="nav-link menu-title" @click="$router.push('roles').catch(err => {})"><grid-icon class="custom-class"></grid-icon><span>{{$t("role management")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('TENANT_INDEPENDENCE')"><a class="nav-link menu-title" @click="$router.push('apps').catch(err => {})"><download-cloud-icon class="custom-class"></download-cloud-icon><span>{{$t("apps")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('TENANT_INDEPENDENCE')"><a class="nav-link menu-title" @click="$router.push('appspecifics').catch(err => {})"><download-cloud-icon class="custom-class"></download-cloud-icon><span>{{$t("appspecificdata")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('TENANT_INDEPENDENCE')"><a class="nav-link menu-title" @click="$router.push('placements').catch(err => {})"><layers-icon class="custom-class"></layers-icon><span>{{$t("placements")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('TENANT_INDEPENDENCE')"><a class="nav-link menu-title" @click="$router.push('placementtypes').catch(err => {})"><layers-icon class="custom-class"></layers-icon><span>{{$t("placementTypes")}}</span></a></li>
                  <li class="dropdown" v-if="$rights.includes('MANAGE_COMPANY_INFORMATION') || $rights.includes('TENANT_INDEPENDENCE')"><a class="nav-link menu-title" @click="$router.push('tenants').catch(err => {})"><briefcase-icon class="custom-class"></briefcase-icon><span>{{ $rights.includes('TENANT_INDEPENDENCE') ? $t("tenants") : $t("company") }}</span></a></li>
                </ul>
              </div>
              <div class="right-arrow" id="right-arrow"><i data-feather="arrow-right"></i></div>
            </div>
          </nav>
        </header>
        <!-- Page Sidebar Ends-->
        <div v-bind:class="[sidebar ? 'ml-0' : '' , $user != null ? 'page-body' : '']" class="">
          <router-view></router-view>
        </div>
        
      </div>

      <!-- Charge Account Modal -->
      <div class="modal fade show" v-show="showChargeAccountPopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("charge_account") }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showChargeAccountPopup = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("charge_account_description") }}</p>
              <div class="row">
                <div class="col">
                  <div class="">
                    <label>{{ $t("amount") }}</label>
                    <div style="display: grid; grid-template-columns: 90% auto">
                      <input class="form-control" type="number" step="1" min="30" @keypress.enter="payWithPayPal()" v-model="charge.amount">
                      <span style="margin: 0 auto;font-size: 22px;">€</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="mb-3">
                    <div style="float: right;text-align: right;padding-right: 15px;font-size: 20px;">
                      <label>19% {{ $t("tax") }}: {{ $formatCurrency(charge.amount * 0.19) }} €</label><br>
                      <label><u>{{ $t("total") }}: {{ $formatCurrency(charge.amount * 1.19) }} €</u></label><br>
                    </div>
                  </div>
                </div>
              </div>
            <div class="modal-footer">
              <button @click="(showChargeAccountPopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
              <button @click="payWithPayPal()" type="button" data-bs-original-title="" title=""><img class="img-fluid" style="height: 35px;" src="/static/images/logo/checkout-logo-large-de.png" height="35" alt=""></button>
              
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Charge Account Modal -->
      <div class="modal fade show" v-show="showPaymentSummaryPopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("payment_summary") }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showPaymentSummaryPopup = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("payment_summary_description") }}</p>
              <div class="row">
                <div class="col">
                  <div class="mb-3">
                    <div style="float: right;text-align: right;padding-right: 15px;font-size: 20px;">
                      <label>{{ $t("charge_account") }}: {{ $formatCurrency(charge.amount) }} €</label><br>
                      <label>19% {{ $t("tax") }}: {{ $formatCurrency(charge.amount * 0.19) }} €</label><br>
                      <label><u>{{ $t("total") }}: {{ $formatCurrency(charge.amount * 1.19) }} €</u></label><br>
                    </div>
                  </div>
                </div>
              </div>
            <div class="modal-footer">
              <button @click="(showPaymentSummaryPopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
              <button @click="confirmPaypal()" class="btn btn-primary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("confirm_payment") }}</button>
              
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Global Search Modal -->
      <div class="modal fade show" v-show="globalSearch != ''" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);margin-top: 90px;padding-right: 0px;" aria-modal="true" role="dialog">
        <div class="modal-dialog" style="margin-top: 0px;margin-left: 288px;max-width: 100%" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <b>{{ $t("advertisements") }}</b>
              <div>
                <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr v-show="searchResultAdvertisements.length == 0">
                          {{ $t("no_entries") }}
                        </tr>
                        <tr v-for="advertisement in searchResultAdvertisements" :key="advertisement.id">
                          <td class="align-middle">
                            <v-img class="rounded-lg" :src="`/files/images/${advertisement.placement.app.icon}`" width="35" :aspect-ratio="1"></v-img>
                          </td>
                          <td>{{advertisement.name}}</td>
                          <td><span class="badge badge-info" style="font-size: 10px">{{ advertisement.placement.namesMap[$locale] }}</span></td>
                          <td style="text-align: right;padding-right: 50px;"><a href="javascript:void(0)" style="text-decoration: underline;" @click="openSearchResult('/edit-advertisement?advertisementId=' + advertisement.id)">{{ $t("details") }}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
              <br>
              <b>{{ $t("targetgroups") }}</b>
              <div>
                <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr v-show="searchResultTargetAudiences.length == 0">
                          {{ $t("no_entries") }}
                        </tr>
                        <tr v-for="aud in searchResultTargetAudiences" :key="aud.id">
                          <td>{{aud.name}}</td>
                          <td style="text-align: right;padding-right: 50px;"><a href="javascript:void(0)" style="text-decoration: underline;" @click="openSearchResult('/edit-targetgroup?targetgroupId=' + aud.id)">{{ $t("details") }}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
              <br>
              <b>{{ $t("users") }}</b>
              <div>
                <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr v-show="searchResultUsers.length == 0">
                          {{ $t("no_entries") }}
                        </tr>
                        <tr v-for="user in searchResultUsers" :key="user.id">
                          <td>{{user.firstname}} {{ user.lastname }}</td>
                          <td>{{user.email}}</td>
                          <td>{{user.allRoles}}</td>
                          <td style="text-align: right;padding-right: 50px;"><a href="javascript:void(0)" style="text-decoration: underline;" @click="openSearchResult('/edit-user?userId=' + user.id)">{{ $t("details") }}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
            <div class="modal-footer">
              <button @click="(globalSearch = '')" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
            </div>
          </div>
        </div>
      </div>
      </div>

    </div>
    </v-app>
  </div>
</template>
<script>
import { SettingsIcon,LogOutIcon,AwardIcon,HomeIcon,AlignCenterIcon,CreditCardIcon,ClipboardIcon,UsersIcon,TargetIcon,LayersIcon,DownloadCloudIcon,TableIcon,SmartphoneIcon,CopyIcon,MaximizeIcon,StarIcon,BellIcon,MessageSquareIcon,GridIcon,BriefcaseIcon,DollarSignIcon } from 'vue-feather-icons'

export default {
  components: {
    SettingsIcon,
    LogOutIcon,
    AwardIcon,
    HomeIcon,
    AlignCenterIcon,
    CreditCardIcon,
    ClipboardIcon,
    UsersIcon,
    TargetIcon,
    TableIcon,
    SmartphoneIcon,
    LayersIcon,
    DownloadCloudIcon,
    CopyIcon,
    MaximizeIcon,
    StarIcon,
    BellIcon,
    MessageSquareIcon,
    GridIcon,
    BriefcaseIcon,   
    DollarSignIcon
  },

  name: "app",
  data() {
    return {
      sidebar: false,
      drawer:null,
      footdrawer:true,
      selectedlanguage:null,
      possiblelanguages: [],
      showChargeAccountPopup: false,
      showPaymentSummaryPopup: false,
      currentBudget: 0,
      profileImage: "/static/images/dashboard/1.png",
      standardRoutes: [
        {
          key: "objects",
          name: this.$t("objects"),
          icon: "fas fa-bomb",
          to: "/findings",
        },
        {
          key: "masterdata",
          name: this.$t("masterdata"),
          icon: "fas fa-database",
          to: "/masterdata",
          right: "WriteMasterdata",
        },
        {
          key: "users",
          name: this.$t("users"),
          icon: "fas fa-user",
          to: "/users",
          right: "ReadUsers",
        },
        {
          key: "roles",
          name: this.$t("roles"),
          icon: "fas fa-user-tag",
          to: "/roles",
          right: "WriteUsers",
        },
        {
          key: "customers",
          name: this.$t("customers"),
          icon: "fas fa-user-tie",
          to: "/customers",
          right: "GlobalAccess",
        },
      ],
      loginRoute: {
        key: "login",
        name: this.$t("login"),
        icon: "fas fa-user",
        to: "/login",
      },
      logoutRoute: {
        key: "logout",
        name: this.$t("logout"),
        icon: "fas fa-sign-out-alt",
      },
      stats: {
        all: 0,
        open: 0,
        created: 0,
        finished: 0,
        rejected: 0,
        inProgress: 0,
      },
      allowedRoutes: [],
      user: null,
      language: {
        language: null,
        flag: null,
        shortForm: null
      },
      languages: [],
      charge: {
        amount: 30,
        currency: "EUR"
      },
      globalSearch: "",
      globalSearchMaxSize: 5,
      searchResultAdvertisements: [],
      searchResultTargetAudiences: [],
      searchResultUsers: [],
      activeAdsCount: 0,
    };
  },

  mounted() {
    this.getCurrentLanguage();
    this.getLanguages();
    this.getCurrentUser();
    this.fetchBudget();
    this.fetchActiveAds();
    console.log(Vue.prototype.$user);

    this.showPaymentSummary();

    jQuery('.submenu-title').append('<div class="according-menu"><i class="fa fa-angle-right"></i></div>');

    Vue.prototype.$changeAmountOfActiveAds = this.changeAmountOfActiveAds;
    Vue.prototype.$reloadAppBudget = this.fetchBudget;
    Vue.prototype.$reloadActiveAds = this.fetchActiveAds;
    Vue.prototype.$reloadAppCurrentUser = this.getCurrentUser;
  },

  computed: {
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },

  methods: {
    getCurrentUser() {
      var _this = this;
      progressIndicator.hidden = false;
      this.$axios
        .get("/api/user/me").then(function(response){
          _this.user = response.data;
          Vue.prototype.$user = _this.user;
          Vue.prototype.$rights = _this.user.allRights;
          if(_this.user.tenant.picture != null && _this.user.tenant.picture != "") _this.profileImage = "/files/images/" + _this.user.tenant.picture;
          _this.$forceUpdate();
        })
        .catch(this.getCurrentUserFailed)
        .finally(this.requestEnded);
    },
    gotCurrentUser(response) {
      this.user = response.data;
      Vue.prototype.$user = this.user;
      this.$forceUpdate();
      Vue.prototype.$rights = this.user.allRights;

      this.allowedRoutes = [];
      for (let i = 0; i < this.standardRoutes.length; i++) {
        const route = this.standardRoutes[i];
        if (route.right == null || this.hasRight(route.right)) {
          this.allowedRoutes.push(route);
        }
      }
    },
    getCurrentUserFailed(error) {
      this.user = null;
      console.error(error);
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    requestEnded() {
      progressIndicator.hidden = true;
    },

    getCurrentLanguage() {
      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .get("/api/language/me")
        .then(function(response){
          _this.language.language = response.data.language;
          _this.language.flag = response.data.flag;
          _this.selectedlanguage = response.data.shortForm;
        })
        .catch(this.onError)
        .finally(this.requestEnded);
    },

    getLanguages() {
      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .get("/api/language/all")
        .then(function(response){
          _this.languages = response.data;
          _this.convertLanguages(_this.languages);
          
          // Make function accessible for getting flag by language
          Vue.prototype.$languages = _this.languages;
        })
        .catch(this.onError)
        .finally(this.requestEnded);
    },
    convertLanguages(languages){
      const lnlist = [];
      for (var i in languages){
        var language = {};
        var ln = languages[i].language;
        
        // console.log(this.$t(languages[i].language));
        language.name = this.$t(languages[i].language);
        language.flag = languages[i].flag;
        language.shortForm = languages[i].shortForm;
        lnlist.push(language);
        
      }
      this.possiblelanguages = lnlist;
    },

    setLanguage(shortForm){
      if(!window.location.href.includes('?')){
        window.location.href = window.location.href + "?lang=" + shortForm; 
      }else{
        window.location.href = window.location.href + "&lang=" + shortForm;
      }
    },

    showCatalog(){
      var win = window.open("/api/downloads/catalog", "_blank");
      win.focus();
    },

    hasRight(right) {
      if (this.user.allRights.includes(right)) return true;
      return false;
    },

    fetchActiveAds() {
      var _this = this;
      this.$axios
        .get("/api/dashboard/activeAds")
        .then(function (response) {
          _this.activeAdsCount = response.data.length;
        })
        .catch(this.onError);
    },

    toggleAuthentication() {
      if (this.user == null) {
        this.router.push("login");
      } else {
        this.logout();
      }
    },
    logout() {
      this.$axios
        .post("/logout")
        .then(this.logoutDone)
        .catch(this.logoutFailed);
    },
    logoutDone(response) {
      Vue.prototype.$user = null;
      this.switchToLoginPage();
    },
    logoutFailed(error) {
      this.switchToLoginPage();
    },
    switchToLoginPage() {
      this.user = null;
      this.$axios.logout();
      this.$router.push("login");
    },

    changeAmountOfActiveAds(value){
      this.activeAdsCount+= value;
    },

    fetchBudget() {
      var _this = this;
      this.$axios
        .get("/api/purchase/budget")
        .then(function (response) {
          _this.currentBudget = response.data;
        })
        .catch(this.onError);
    },
    nothing() {},
    // Payment Stuff
    payWithPayPal(){
      if(this.charge.amount == 0 || isNaN(this.charge.amount)) return;
      if(this.charge.amount < 30){
        this.$noty.error(this.$t("paypal_too_small_amount"));
        return;
      }
      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .post("/api/purchase/paypal", this.charge)
        .then(function(response){
          window.location.href = response.data.approvalLink;
        })
        .catch(e => {
          _this.$noty.error(e.response.data);
        }).finally(() => {
          progressIndicator.hidden = true;
        });
    },
    showPaymentSummary(){
      var url = new URL(window.location.href);
      var token = url.searchParams.get("token");
      if(token == null) return;
      if(window.location.href.includes("reset-password")) return;
      this.fetchPayPalPaymentCharge();
    },
    fetchPayPalPaymentCharge(){
      var url = new URL(window.location.href);
      var token = url.searchParams.get("token");
      if(token == null) return;

      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .get("/api/purchase/paypal/order/" + token)
        .then(function(response){
          _this.charge.amount = response.data.price;
          _this.showPaymentSummaryPopup = true;
        })
        .catch(e => {
          _this.$noty.error(e.response.data);
        }).finally(() => {
          progressIndicator.hidden = true;
        });
    },
    confirmPaypal(){
      var url = new URL(window.location.href);
      var token = url.searchParams.get("token");
      if(token == null) return;

      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .post("/api/purchase/paypal/capture/" + token)
        .then(function(response){
          _this.$noty.success(_this.$t("paypal_success"));
          window.location.href = window.location.href.substring(0, window.location.href.indexOf("?"));
        })
        .catch(e => {
          _this.$noty.error(e.response.data);
        }).finally(() => {
          progressIndicator.hidden = true;
        });
    },
    fetchAdvertisements(){
      var _this = this;
      this.$axios
        .get("/api/advertisement", {
          params: {
            search: this.globalSearch,
            page: 0,
            size: this.globalSearchMaxSize
          }})
        .then(function (response) {
          _this.searchResultAdvertisements = response.data.content;
        })
        .catch(this.onError);
    },
    fetchTargetAudiences(){
      var _this = this;
      this.$axios
        .get("/api/targetaudience", {
          params: {
            search: this.globalSearch,
            page: 0,
            size: this.globalSearchMaxSize
          }})
        .then(function (response) {
          _this.searchResultTargetAudiences = response.data.content;
        })
        .catch(this.onError);
    },
    fetchUsers(){
      var _this = this;
      this.$axios
        .get("/api/user", {
          params: {
            search: this.globalSearch,
            page: 0,
            size: this.globalSearchMaxSize
          }})
        .then(function (response) {
          _this.searchResultUsers = response.data.content;
        })
        .catch(this.onError);
    },
    openSearchResult(link){
      this.globalSearch = "";
      this.$router.push(link).catch(err => {});
    }
  },
  watch: {
    $route(to, from) {
      if (from.path === "/login" && to.path !== "/reset-password") {
        this.getCurrentUser();
      }
    },
    globalSearch(val){
      if(this.globalSearch == ""){
        return;
      }
      this.fetchAdvertisements();
      this.fetchTargetAudiences();
      this.fetchUsers();
    }
  },
};
</script>
